/* eslint-disable import/first */
import React from 'react';
import { Grid, Radio } from '@material-ui/core';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
import { useNavigate } from '@reach/router';
import { RiErrorWarningLine } from '@react-icons/all-files/ri/RiErrorWarningLine';
const { useSelector } = Redux;
import { numberWithSpaces, capitalizeFirstLetter } from 'spwa-ui-library/esm/utils/helper';
const { selectBaseURL, selectCountryValidations } = Slices.configSlice;
const { selectDesktop } = Slices.appSlice;
const { selectCurrentCountry } = Slices.profileSlice;
import { useIntl } from 'react-intl';

import css from './index.module.scss';
import LightningPayToggle from '../../../components/LightningPayToggle';

const SavedCardView = ({
  cardList,
  handleSelectedCard,
  cardToken,
  checkLightningPay,
  toggleLighteningPayHandler,
  countryLightningPayStatus,
  lightningPayMaxAmount,
  currency,
  fetchCardListHandler,
}) => {
  const productImgBaseUrl = useSelector(selectBaseURL);
  const navigate = useNavigate();
  const intl = useIntl();
  const isDesktop = useSelector(selectDesktop);
  const country = useSelector(selectCurrentCountry);
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const maskTheCard = (cardNo) => {
    const newop = cardNo.replace(/.(?=.{4})/g, '•');
    return numberWithSpaces(newop, '####  ####  ####  ####');
  };

  return (
    <Grid className={css.cardsRoot}>
      {cardList.map((each) => {
        return (
          <Grid className={css.cardContainerArea}>
            {/* <Grid className={each.brand === 'VISA' ? css.visaCardProps : css.masterCardProps}> */}
            <Grid
              onClick={() => handleSelectedCard(each.token, each.cardNo)}
              className={css.cardProps}
            >
              <img
                src={`${productImgBaseUrl?.home}/py_card_bg_${each.brand.toLowerCase()}.png`}
                className={css.bgImage}
                alt=""
              />
              <Grid className={css.cardProperties}>
                <Grid className={css.cardSelector}>
                  <Grid className={css.cardName}>
                    {capitalizeFirstLetter(each.type)} {capitalizeFirstLetter(each.mode)}
                  </Grid>
                  <Grid className={css.cardRadio}>
                    <Radio edge="end" checked={cardToken === each.token} />
                  </Grid>
                </Grid>
                <Grid className={css.cardNumber}>{maskTheCard(each.cardNo)}</Grid>
                <Grid className={css.fgContainer}>
                  {countryLightningPayStatus && (
                    <LightningPayToggle
                      doNotShowWarning={true}
                      checkLightningPay={() => {
                        checkLightningPay(each);
                      }}
                      cardToken={each.token}
                      toggleLighteningPayHandler={(status, token) => {
                        toggleLighteningPayHandler(status, token);
                        fetchCardListHandler();
                      }}
                      checked={each.isLightningBlocked === 0 ? true : false}
                    />
                  )}
                  <img
                    src={`${productImgBaseUrl?.home}/py_card_fg_${each.brand.toLowerCase()}.png`}
                    className={css.fgImage}
                    alt=""
                  />
                </Grid>
              </Grid>
            </Grid>
            {!isDesktop && countryValidations.lightningPayConfig?.lightningPay && (
              <div className={css.lightningPayWarningConainer}>
                <div className={css.lightningPayWarningText}>
                  {intl.formatMessage(
                    { id: 'lightning_pay_terms_text' },
                    {
                      amount: lightningPayMaxAmount,
                      currency,
                    }
                  )}
                </div>
                <RiErrorWarningLine
                  onClick={() => navigate(`/${intl.locale}/faq`)}
                  className={css.warningIcon}
                />
              </div>
            )}
          </Grid>
        );
      })}
      {isDesktop && countryValidations.lightningPayConfig?.lightningPay && (
        <div className={css.lightningPayWarningConainer}>
          <div className={css.lightningPayWarningText}>
            {intl.formatMessage(
              { id: 'lightning_pay_terms_text' },
              {
                amount: lightningPayMaxAmount,
                currency,
              }
            )}
          </div>
          <RiErrorWarningLine
            onClick={() => navigate(`/${intl.locale}/faq`)}
            className={css.warningIcon}
          />
        </div>
      )}
    </Grid>
  );
};

export default SavedCardView;
